import React from 'react';
import { Form, ModalBody, Button, ModalFooter } from 'reactstrap';

export const DeletePatient = (props) => {

    const {
        toggle, loading, paternal_surname, maternal_surname, name, saveDelete
    } = props;

    return (
        <Form className="theme-form" role="form" onSubmit={saveDelete}>
            <ModalBody>
                <p className="h6 txt-danger">Estas a punto de eliminar al paciente con nombre:</p>                
                <b>{ name+' '+paternal_surname+' '+maternal_surname}</b>
                <br />
                <p>¿Estás seguro de hacerlo?</p>
            </ModalBody>
            <ModalFooter>
                <Button
                    size="sm"
                    color="primary"
                    type="submit"
                    className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                    >
                    Sí, eliminar
                </Button>
                <Button size="sm" className="btn-air-light" color="light" type="button" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Form>
    )
}
